module.exports = __webpack_public_path__ + "static/media/storyEndframe.362e80be.png";